import apiClient from '@/services/api/apiClient';

export interface Remark { id: string; note: string; by: string; at: string; }

export interface ActivityItem {
  id: string;
  refType: 'EMAIL' | 'EVENT' | 'CALL' | 'MANUAL_CALL' | 'MQL';
  refId: string;
  type: 'email' | 'event' | 'call' | 'mql';
  subType?: string;   // raw engagement event type for EVENT rows (OPEN, CLICK, DOWNLOAD…)
  occurrence?: number; // 1 = first time, >1 = genuine repeat (re-open / re-visit)
  when: string;
  title: string;
  subtitle?: string;
  contactId?: string | null;
  contactName?: string;
  accountName?: string;
  magnetId?: string | null;
  magnetTitle?: string | null;
  remarks: Remark[];
}

export interface FollowUp {
  id: string;
  title: string;
  notes?: string | null;
  dueDate?: string | null;
  done: boolean;
  priority: 'low' | 'normal' | 'high';
  contactId?: string | null;
  accountId?: string | null;
  contactName?: string;
  accountName?: string;
  createdAt: string;
}

export const activityService = {
  async getFeed(days = 14): Promise<{ items: ActivityItem[]; total: number }> {
    const { data } = await apiClient.get('/api/activity/feed', { params: { days } });
    return data;
  },
  async addRemark(input: { refType: string; refId: string; contactId?: string | null; accountId?: string | null; note: string }): Promise<Remark> {
    const { data } = await apiClient.post('/api/activity/remark', input);
    return data;
  },
  async getFollowUps(done?: boolean): Promise<{ items: FollowUp[] }> {
    const { data } = await apiClient.get('/api/followups', { params: done === undefined ? {} : { done } });
    return data;
  },
  async createFollowUp(input: { title: string; notes?: string; dueDate?: string | null; priority?: string; contactId?: string | null }): Promise<FollowUp> {
    const { data } = await apiClient.post('/api/followups', input);
    return data;
  },
  async updateFollowUp(id: string, patch: Partial<FollowUp>): Promise<FollowUp> {
    const { data } = await apiClient.patch(`/api/followups/${id}`, patch);
    return data;
  },
  async deleteFollowUp(id: string): Promise<void> {
    await apiClient.delete(`/api/followups/${id}`);
  },
};
